module.exports = __webpack_public_path__ + "static/empty-states-headlines-dont-efd666b82167db9f15a66179bf24022e.png";